export const refreshPage = () => document.location.reload();
